import { Navbar } from "../components/navbar";
import { NavbarLogo } from "../components/navbarLogo";
import { SelectedWorks } from "../components/selectedWorks";
import { useAnimation, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Footer } from "../components/footer";
import { Collab } from "../components/collab";
import { Expertise2 } from "../components/expertise2";
import { Link as ScrollLink } from "react-scroll";

export const Home = () => {
    const controls = useAnimation();
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            setScrollPosition(window.scrollY);
        };

        window.addEventListener("scroll", handleScroll);

        // Cleanup the event listener on component unmount 
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        // Adjust the scroll threshold as needed
        const scrollThreshold = 10; // Adjust this value based on when you want the animation to start

        if (scrollPosition > scrollThreshold) {
            controls.start({ rotate: 40 });
        } else {
            controls.start({ rotate: 0 });
        }
    }, [scrollPosition, controls]);

    return (
        <>
            <Navbar />
            <section
                id="home"
                className="relative px-[16px] md:px-[32px] lg:px-[160px] font-jakarta relative bg-[#002921] h-[100svh] flex flex-col justify-center md:justify-between"
            >
                <div className="pt-[2.2rem] pl-[10px] md:px-0">
                    <NavbarLogo />
                </div>
                <motion.section
                    // variants={showAnimationVariant}
                    initial="hidden"
                    animate="show"
                    className="px-[16px] md:px-0  flex flex-col mt-auto md:mt-0 text-white font-semibold md:font-medium text-[2.6rem] md:text-[4.6rem] leading-snug md:leading-tight "
                >
                    <motion.span
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.2 }}
                        className="md:hidden "
                    >
                        Hello! I'm Thoby
                    </motion.span>
                    <motion.span
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.2 }}
                        className="hidden md:block"
                    >
                        Hi there, I'm Thoby
                    </motion.span>
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.4 }}
                        className="flex items-center mt-[0.5rem] md:mt-0"
                    >
                        <span className="hidden md:block text-[#E0FD60] pb-[0.4rem] text-[2rem] lg:text-[3.4rem]">
                            •
                        </span>
                        <div className="flex flex-col md:flex-row md:pl-[1.3rem]">
                            <span className="whitespace-pre">a full stack </span>
                            <div className="relative text-[#E0FD60]">
                                developer
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 387 92"
                                    width="387"
                                    height="92"
                                    className="absolute left-[-0.5rem] md:left-[0.5rem] top-[-1rem] md:top-[0rem] opacity-[0.4] w-full scale-[1.1] md:scale-[1.15]"
                                >
                                    <g clip-path="url(#__lottie_element_5)">
                                        <g opacity="1">
                                            <g opacity="1">
                                                <g opacity="1">
                                                    <path
                                                        stroke-linecap="butt"
                                                        stroke-linejoin="miter"
                                                        fill-opacity="0"
                                                        stroke-miterlimit="4"
                                                        stroke="#E0FD60"
                                                        stroke-opacity="1"
                                                        stroke-width="3"
                                                        d=" M351.510009765625,28.700000762939453 C326.57000732421875,19.18000030517578 255.05999755859375,3.309999942779541 123.72000122070312,14.779999732971191 C-76.05000305175781,32.22999954223633 3.7300000190734863,81.98999786376953 123.72000122070312,88.02999877929688 C223.30999755859375,93.04000091552734 385,91.41999816894531 385,47.29999923706055 C385,4.690000057220459 216.57000732421875,-5.96999979019165 133.89999389648438,7.440000057220459"
                                                    ></path>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.6 }}
                        className="flex flex-col md:flex-row"
                    >
                        <div>and digital</div>
                        <span className="hidden md:block whitespace-pre"> </span>
                        <div className="relative text-[#E0FD60] whitespace-pre">
                            designer.
                        </div>
                    </motion.div>
                </motion.section>
                <motion.section
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut", delay: 1 }}
                    className="px-[16px] md:px-0 flex justify-between relative mb-auto md:mb-[5rem] mt-[2rem] md:mt-0"
                >
                    <section className="flex items-center gap-[0.3rem]">
                        <ScrollLink
                            to="works"
                            id="button-animation"
                            className="rounded-full border border-[#747474] text-[1.1rem] text-[#c8c8cb] py-[1rem] md:py-[1.2rem] px-[1.4rem] md:px-[1.6rem]"
                        >
                            View my work
                        </ScrollLink>
                        <div className="flex items-center justify-center p-[1.1rem] md:p-[1.2rem] rounded-full bg-[#E0FD60]">
                            <svg
                                viewBox="0 0 26 26"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="rotate-90 h-[24px] w-[24px] md:h-[26px] md:w-[26px]"
                            >
                                <path
                                    d="M10.3291 5.68945H20.6694C20.727 5.68945 20.7738 5.73622 20.7738 5.7939V16.1342"
                                    stroke="#22333B"
                                    stroke-width="2.08894"
                                    stroke-miterlimit="10"
                                ></path>
                                <path
                                    d="M20.7744 5.68945L7.19629 19.2676"
                                    stroke="#22333B"
                                    stroke-width="2.08894"
                                    stroke-miterlimit="10"
                                ></path>
                            </svg>
                        </div>
                    </section>
                </motion.section>
            </section>
            {/* <Expertise /> */}
            <Expertise2 />
            <section id="works">
                <SelectedWorks />
            </section>
            <section id="collab">
                <Collab />
            </section>
            <Footer />
        </>
    );
};
